import './FlowDiagram.css';

function FlowDiagram({ steps }) {
  return (
    <div className="flow-diagram">
      {steps.map((step, index) => (
        <div key={step} className="flow-diagram-item" style={{ '--anim-delay': `${index * 0.5}s` }}>
          <div className="flow-diagram-node">{step}</div>
          {index < steps.length - 1 && <div className="flow-diagram-arrow">↓</div>}
        </div>
      ))}
    </div>
  );
}

export default FlowDiagram;
